import Typography from '@mui/material/Typography';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { useCompanyCore } from '../../../core/modules/company';
import { Box, Button, Input } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { debounce } from 'lodash';
import { useGlobalCore } from '../../../core/modules/global';
import { CREATE_COMPANY_DIALOG } from '../../../core/constants/dialog';
import { useUserCore } from '../../../core/modules/user';
import { UserType } from '../../../core/enums/userType.enum';

const Header = () => {
  const { companies, setOptions } = useCompanyCore();
  const { getUsers } = useUserCore();
  const { openDialog } = useGlobalCore();

  const [searchTxt, setSearchTxt] = useState<string>('');

  const debouncedOnChange = debounce(setSearchTxt, 500);

  useEffect(() => {
    setOptions({
      text: searchTxt,
    });
  }, [searchTxt, setOptions]);

  const openingDialog = useCallback(() => {
    getUsers({ role: UserType.user });
    openDialog(CREATE_COMPANY_DIALOG);
  }, [getUsers, openDialog]);

  return (
    <div className="p-24 sm:p-32 w-full border-b-1 bg-white">
      <div className="flex flex-col items-center sm:items-start">
        <Typography className="text-24 md:text-32 font-extrabold tracking-tight leading-none">
          Compañías
        </Typography>
        <Typography className="text-14 font-medium ml-2" color="text.secondary">
          {companies.length} compañías
        </Typography>
      </div>
      <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center mt-16 -mx-8">
        <Box className="flex flex-1 w-full sm:w-auto items-center px-16 mx-8 border-1 rounded-full">
          <SearchOutlinedIcon />

          <Input
            placeholder="Buscar compañías"
            className="flex flex-1 px-16"
            disableUnderline
            fullWidth
            onChange={(e) => debouncedOnChange(e.target.value)}
          />
        </Box>
        <Button
          className="mx-8"
          variant="contained"
          color="secondary"
          onClick={openingDialog}
        >
          <AddCircleOutlineOutlinedIcon />
          <span className="mx-8">Crear</span>
        </Button>
      </div>
    </div>
  );
};

export default Header;
